import { NavigationGuardNext, Route } from 'vue-router';

import { LIST_PERMISSION } from '@/constant/ListPermission';

import store from '@/store';

import Permission from './index';

import { NAME_ROUTES_DASHBOARD } from '../../routes/Dashboard';

function userInstitution() {
  return store?.getters?.profile?.institution;
}
export function permissionQuestion(to: Route, from: Route, next: NavigationGuardNext<Vue>) {
  const PermissionClass = new Permission();
  const verifyPermissionQuestion = PermissionClass.can(LIST_PERMISSION.DB_QUESTIONS);

  if (!verifyPermissionQuestion) {
    next({
      name: NAME_ROUTES_DASHBOARD.DASHBOARD
    });

    return;
  }

  next();
}

export function permissionQuestionList(to: Route, from: Route, next: NavigationGuardNext<Vue>) {
  const PermissionClass = new Permission();

  const verifyPermissionQuestion = PermissionClass.can(LIST_PERMISSION.DB_QUESTIONS);

  if (!verifyPermissionQuestion) {
    next({
      name: NAME_ROUTES_DASHBOARD.DASHBOARD
    });

    return;
  }

  next();
}
